export var log = function (objects) {
    objects.forEach(function (loggable) {
        console.log("".concat(loggable.label, ":"), loggable.content);
    });
};
